import React from 'react';
import { FormControl, FormLabel, FormControlLabel, Checkbox } from '@material-ui/core';
import { CheckboxLayoutItem } from 'models/InputLayoutItem';
import { Control, FieldValues, Controller } from 'react-hook-form';
import 'assets/scss/checkbox-layout.scss';

interface CheckboxProps extends CheckboxLayoutItem {
	control: Control<FieldValues>;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	joinedComponent?: any;
}

export const CheckboxLayout = ({
	label,
	name,
	control,
	defaultValue,
	handleChange,
	joinedComponent,
}: CheckboxProps) => {
	return (
		<div className="checkbox-component">
			{
				<Controller
					key={name}
					name={name}
					control={control}
					defaultValue={defaultValue}
					render={({ field }) => (
						<FormControl component="fieldset">
							<FormLabel component="legend" color="primary">
								{label}
							</FormLabel>
							<FormControlLabel
								control={<Checkbox onChange={handleChange} name={name} color={'primary'} />}
								label={''}
							/>
						</FormControl>
					)}
				/>
			}
			{joinedComponent ? (
				<div className={'checkbox-joined_component'}>{joinedComponent}</div>
			) : null}
		</div>
	);
};
